import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-9 text-center">
          <span className="text-sm font-bold tracking-wide text-accent-700">FAQ</span>
          <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">常见问题</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
            关于追更、更新节奏与内容的疑问，这里都有答案。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border bg-background-50 transition-colors ${
                  isOpen ? "border-accent-300" : "border-background-200"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="text-base font-bold text-foreground-950 md:text-lg">{f.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-base transition-transform ${
                      isOpen ? "rotate-45 bg-accent-500 text-foreground-950" : "bg-background-100 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((f) => ({
              "@type": "Question",
              name: f.q,
              acceptedAnswer: { "@type": "Answer", text: f.a },
            })),
          }),
        }}
      />
    </section>
  );
}